/* Where to buy — 标签切换
   支持:点击、方向键/Home/End 键盘导航、URL hash 深链(#domestic 等,
   与 WordPress 旧链接保持兼容)。 */
if (!customElements.get('where-to-buy')) {
	class WhereToBuy extends HTMLElement {
		connectedCallback() {
			this.tabs = Array.from(this.querySelectorAll('.wtb--tab'));
			this.panels = Array.from(this.querySelectorAll('.wtb--panel'));
			if (!this.tabs.length) return;

			this.tabs.forEach((tab, i) => {
				tab.addEventListener('click', () => this.select(i));
				tab.addEventListener('keydown', (e) => this.onKeydown(e, i));
			});

			this.selectFromHash();
			window.addEventListener('hashchange', () => this.selectFromHash());
		}

		/* 旧 WordPress 链接形如 /where-to-buy/#government,按标签名匹配 */
		selectFromHash() {
			const hash = decodeURIComponent(window.location.hash.replace('#', '')).toLowerCase();
			if (!hash) return;
			const i = this.tabs.findIndex(
				(t) => t.textContent.trim().toLowerCase().replace(/\s+/g, '-') === hash
			);
			if (i > -1) this.select(i, false);
		}

		select(index, focus = true) {
			this.tabs.forEach((tab, i) => {
				const active = i === index;
				tab.classList.toggle('is-active', active);
				tab.setAttribute('aria-selected', active ? 'true' : 'false');
				tab.tabIndex = active ? 0 : -1;
			});
			this.panels.forEach((panel, i) => {
				const active = i === index;
				panel.classList.toggle('is-active', active);
				panel.hidden = !active;
			});
			if (focus) this.tabs[index].focus();
		}

		onKeydown(event, index) {
			const last = this.tabs.length - 1;
			let next = null;
			switch (event.key) {
				case 'ArrowRight': next = index === last ? 0 : index + 1; break;
				case 'ArrowLeft': next = index === 0 ? last : index - 1; break;
				case 'Home': next = 0; break;
				case 'End': next = last; break;
				default: return;
			}
			event.preventDefault();
			this.select(next);
		}
	}

	customElements.define('where-to-buy', WhereToBuy);
}
